/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Growth_Bullet_4Inputs */

const en_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any Iowa Section PGA member welcome to teach at the facility`)
};

const es_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier miembro de la Iowa Section PGA es bienvenido a enseñar en la instalación`)
};

const de_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes PGA-Mitglied der Iowa Section ist herzlich willkommen, in der Einrichtung zu unterrichten`)
};

const zh_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎任何爱荷华州分部 PGA 会员在该设施任教`)
};

const ar_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أي عضو في Iowa Section PGA مرحب به للتدريس في المنشأة`)
};

const fr_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout membre de la PGA de la section Iowa est invité à enseigner dans l'établissement`)
};

const vi_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi thành viên Iowa Section PGA đều được chào đón giảng dạy tại cơ sở`)
};

const sw_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwanachama yeyote wa PGA wa Sehemu ya Iowa anakaribishwa kufundisha kwenye kituo`)
};

const th_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยินดีให้สมาชิก PGA ของ Iowa Section มาสอนที่สถาบันแห่งนี้`)
};

const bs_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaki član Iowa Section PGA dobrodošao je da podučava u objektu`)
};

const ja_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワセクションのPGA会員は誰でも当施設で指導可能`)
};

const ko_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Section PGA 회원이라면 누구나 이 시설에서 지도할 수 있습니다`)
};

const pt_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer membro da Seção de Iowa da PGA é bem-vindo para dar aulas no local`)
};

const it_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni membro della Iowa Section PGA è il benvenuto come insegnante presso la struttura`)
};

const sv_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla PGA-medlemmar i Iowa Section är välkomna att undervisa på anläggningen`)
};

const nl_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk PGA-lid van de Iowa Section is welkom om op de faciliteit les te geven`)
};

const da_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ethvert Iowa Section PGA medlem velkommen til at undervise på anlægget`)
};

const nb_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle PGA-medlemmer i Iowa Section er velkommen til å undervise på anlegget`)
};

const fi_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki Iowa Section PGA:n jäsenet ovat tervetulleita opettamaan kentällä`)
};

const pl_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy członek Iowa Section PGA jest mile widziany jako instruktor w obiekcie`)
};

const ru_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любой член Iowa Section PGA может преподавать на площадке`)
};

const tr_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Section PGA'nın her üyesi tesiste ders vermeye davetlidir`)
};

const hi_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Section PGA का कोई भी सदस्य इस सुविधा में पढ़ाने के लिए आमंत्रित है`)
};

const id_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap anggota PGA Iowa Section dipersilakan mengajar di fasilitas ini`)
};

const ms_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mana-mana ahli PGA Seksyen Iowa dialu-alukan untuk mengajar di kemudahan ini`)
};

const cs_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý člen Iowa Sekce PGA je vítán k výuce v zařízení`)
};

const el_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάθε μέλος του Iowa Section PGA είναι ευπρόσδεκτο να διδάσκει στις εγκαταστάσεις`)
};

const he_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל חבר ב-Iowa Section PGA מוזמן ללמד במתקן`)
};

const af_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enige Iowa Section PGA-lid welkom om by die fasiliteit te onderrig`)
};

const hu_about_content_growth_bullet_4 = /** @type {(inputs: About_Content_Growth_Bullet_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa Section PGA bármely tagját szívesen látjuk oktatóként a létesítményben`)
};

/**
* | output |
* | --- |
* | "Any Iowa Section PGA member welcome to teach at the facility" |
*
* @param {About_Content_Growth_Bullet_4Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_growth_bullet_4 = /** @type {((inputs?: About_Content_Growth_Bullet_4Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Growth_Bullet_4Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_growth_bullet_4(inputs)
	if (locale === "de") return de_about_content_growth_bullet_4(inputs)
	if (locale === "zh") return zh_about_content_growth_bullet_4(inputs)
	if (locale === "ar") return ar_about_content_growth_bullet_4(inputs)
	if (locale === "fr") return fr_about_content_growth_bullet_4(inputs)
	if (locale === "vi") return vi_about_content_growth_bullet_4(inputs)
	if (locale === "sw") return sw_about_content_growth_bullet_4(inputs)
	if (locale === "th") return th_about_content_growth_bullet_4(inputs)
	if (locale === "bs") return bs_about_content_growth_bullet_4(inputs)
	if (locale === "ja") return ja_about_content_growth_bullet_4(inputs)
	if (locale === "ko") return ko_about_content_growth_bullet_4(inputs)
	if (locale === "pt") return pt_about_content_growth_bullet_4(inputs)
	if (locale === "it") return it_about_content_growth_bullet_4(inputs)
	if (locale === "sv") return sv_about_content_growth_bullet_4(inputs)
	if (locale === "nl") return nl_about_content_growth_bullet_4(inputs)
	if (locale === "da") return da_about_content_growth_bullet_4(inputs)
	if (locale === "nb") return nb_about_content_growth_bullet_4(inputs)
	if (locale === "fi") return fi_about_content_growth_bullet_4(inputs)
	if (locale === "pl") return pl_about_content_growth_bullet_4(inputs)
	if (locale === "ru") return ru_about_content_growth_bullet_4(inputs)
	if (locale === "tr") return tr_about_content_growth_bullet_4(inputs)
	if (locale === "hi") return hi_about_content_growth_bullet_4(inputs)
	if (locale === "id") return id_about_content_growth_bullet_4(inputs)
	if (locale === "ms") return ms_about_content_growth_bullet_4(inputs)
	if (locale === "cs") return cs_about_content_growth_bullet_4(inputs)
	if (locale === "el") return el_about_content_growth_bullet_4(inputs)
	if (locale === "he") return he_about_content_growth_bullet_4(inputs)
	if (locale === "af") return af_about_content_growth_bullet_4(inputs)
	if (locale === "hu") return hu_about_content_growth_bullet_4(inputs)
	return en_about_content_growth_bullet_4(inputs)
});